export default __webpack_public_path__ + "static/media/paper_gray.1f61846d.svg";